import { IModalProps } from "./IModalProps.ts";
import Button from "../buttons/Button.tsx";
import { ButtonSize, ButtonVariant } from "../../types/button.ts";
import { AppStateService } from "../../services/appStateService.ts";
import { useContext } from "react";
import { AppMainStateContext } from "../../contexts/AppMainStateContext.tsx";
import ButtonLink from "../buttons/ButtonLink.tsx";
import { XCircleIcon } from "@heroicons/react/24/outline";

export const CookieAgreeModal = ({ isOpen, onClose }: IModalProps) => {
    const _appStateService = new AppStateService();
    const { setIsCookiesAgreed, openModal } = useContext(AppMainStateContext);

    const handleCookiesAgreedClick = (isAgreed: boolean) => {
        _appStateService.setIsCookiesAgreed(isAgreed);
        setIsCookiesAgreed(isAgreed);
        openModal();
    };
    return (
        <div
            className={`popup fixed w-screen h-screen inset-0 z-50 overflow-hidden`}
            data-open={isOpen ? isOpen : undefined}
        >
            <div className={"relative h-full bg-neutral-900/60"} />
            <div className={`absolute top-1/2 -translate-y-1/2 right-0 bg-neutral-700 left-1/2 -translate-x-1/2 rounded-3xl w-full max-w-[90%] md:max-w-120`}>
                <div className={"relative"}>
                    <button
                        className={"absolute right-1 -top-11"}
                        onClick={() => onClose()}
                    >
                        <XCircleIcon
                            className={"w-9 h-9 text-neutral-200 hover:text-white transition-colors stroke-[1.5]"}
                        />
                    </button>
                    <div className={"flex flex-col items-center p-8 pt-12 space-y-5"}>
                        <span className={"space-y-4 text-neutral-300"}>
                            <h4 className={"text-white font-extrabold text-2xl"}>
                                Zgoda na pliki cookie
                            </h4>
                            <p className={"text-base"}>
                                W celu zapewnienia najlepszej obsługi, używamy pliki cookie zgodnie z naszą <ButtonLink
                                    className={"pl-0 pr-0 text-sky-500"} to={"/polityka-prywatnosci"} variant={ButtonVariant.TERTIARY}>polityką prywatności</ButtonLink>.
                                Niektóre cookie są wymagane do prawidłowego działania strony
                                (zawsze włączone). Opcjonalne pliki cookie pomagają w
                                personalizacji treści dla użytkownika.
                            </p>
                        </span>
                        <div
                            className={"flex flex-col-reverse md:flex-row text-sm md:space-x-4 w-full md:w-auto gap-2 space-y-2 md:space-y-0"}
                        >
                            <Button
                                variant={ButtonVariant.SECONDARY}
                                size={ButtonSize.BASE}
                                onClick={() => {
                                    handleCookiesAgreedClick(false)
                                }}
                            >
                                Odrzuć
                            </Button>
                            <Button
                                variant={ButtonVariant.PRIMARY}
                                size={ButtonSize.BASE}
                                onClick={() => {
                                    handleCookiesAgreedClick(true)
                                }}
                            >
                                Przejdź do serwisu
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};